import { ajaxErrorAlert, ajaxPost } from "../utils";
import { SuccessSwal, SwalPost } from "../../app";

$(function () {
  const body = $("body");

  if (body.hasClass("teacher-list")) {
    const table = $("#teachersTable");
    const form = $("#teachersFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        if ($(this).find("th[data-column=actions]").length > 0) {
          const rowActions = `
          <a href="/gopanel/videos/?teacher__id=${aData["id"]}" class="btn btn-sm btn-kms-gradient">
            Videolar
          </a>
          <div class="btn-group" role="group">
            <button type="button" class="rowActionMenuBtn btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              Əməliyyat
            </button>
            <ul class="rowActionMenu dropdown-menu rounded-1 shadow">
              <div class="d-flex justify-content-center align-items-center p-2">
                <div class="spinner-border text-secondary" role="status" style="border-width: 1px"></div>
              </div>
            </ul>
          </div>`;
          $(nRow).find("td:last-of-type").append(rowActions);
        }
        if ("id" in aData) {
          $(nRow).attr("id", aData["id"]);
        }
      },
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const rowId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      ajaxPost(rowId + "/action-buttons/", {}, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
    });
  }

  if (
    body.hasClass("teacher-list") ||
    body.hasClass("teacher-update") ||
    body.hasClass("teacher-detail")
  ) {
    $(document).on("click", ".deleteTeacher", (e) => {
      e.preventDefault();
      const url = $(e.currentTarget).attr("href");
      SwalPost(
        url,
        {},
        {
          text: "Müəllim məlumatını silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then((response) => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          window.location.href = String(response["redirect_url"]);
        });
      });
    });
  }

  if (body.hasClass("teacher-create") || body.hasClass("teacher-update")) {
    const form = $("#createUpdateTeacherForm");

    form.on("submit", (e) => {
      e.preventDefault();

      ajaxPost("", form.serializeArray(), form)
        .then((response) => {
          SuccessSwal.fire({ timer: 1000 }).then(() => {
            window.location.href = String(response["redirect_url"]);
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }
});
